import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { HelmetProvider } from 'react-helmet-async';
import ReactGA from "react-ga4";
import { initPinterestPixel } from './utils/pinterest';
import { initFacebookPixel } from './utils/facebook';
import { isAnalyticsAllowed, isMarketingAllowed } from './utils/cookieConsent';

// --- TRACKING SETUP (Respects Cookie Consent) ---
const initializeTracking = () => {
  const analyticsAllowed = isAnalyticsAllowed();
  const marketingAllowed = isMarketingAllowed();

  // Google Analytics - Analytics category
  if (analyticsAllowed) {
    const GA_MEASUREMENT_ID = "G-RCF7Q52JJB";
    ReactGA.initialize(GA_MEASUREMENT_ID);
  }

  // Pinterest & Facebook - Marketing category
  if (marketingAllowed) {
    initPinterestPixel();
    initFacebookPixel();
  }
};

// Initialize tracking based on consent
initializeTracking();



const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HelmetProvider>  {/* <-- 2. WRAP YOUR APP */}
      <App />
    </HelmetProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
